export default "__VITE_ASSET__CGvU9koJ__"